export default __webpack_public_path__ + "static/media/SarahProfile.0ed03c4b.png";